import { render, staticRenderFns } from "./S3_P1_ThankYou.vue?vue&type=template&id=d2cf6918&scoped=true&"
import script from "./S3_P1_ThankYou.vue?vue&type=script&lang=js&"
export * from "./S3_P1_ThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cf6918",
  null
  
)

export default component.exports